import { useEffect, useMemo, useRef, useState } from "react";
import qs from "qs";
import { useSearchParams } from "react-router-dom";

interface UseScrollMemoryParams {
  timeoutDelay?: number;
}

const useScrollMemory = (props?: UseScrollMemoryParams) => {
  const { timeoutDelay = 0 } = props || {};
  const ref = useRef<HTMLDivElement>(null);
  const [refCurrent, setRefCurrent] = useState<HTMLDivElement | null>();
  const [searchParams, setSearchParams] = useSearchParams();
  const { scrollTop, ...params } = useMemo(() => qs.parse(searchParams.toString()), [searchParams]) as {
    scrollTop?: string;
  };
  const paramsRef = useRef<typeof params>(params);

  useEffect(() => {
    if (paramsRef) paramsRef.current = params;
  }, [params]);

  useEffect(() => {
    const { current } = ref;
    if (current) {
      setRefCurrent(current);
    }
  }, [ref]);

  const handleCurrentScroll = () => {
    if (refCurrent) {
      const currentScrollTop = Math.round(refCurrent.scrollTop);

      const currentParams = paramsRef.current;
      if (currentScrollTop) {
        setSearchParams(qs.stringify({ ...currentParams, scrollTop: currentScrollTop }), { replace: true });
      } else {
        setSearchParams(qs.stringify(currentParams), { replace: true });
      }
    }
  };

  useEffect(() => {
    if (refCurrent) {
      refCurrent.addEventListener("scroll", handleCurrentScroll);
    }

    return () => {
      refCurrent?.removeEventListener("scroll", handleCurrentScroll);
    };
  }, [refCurrent]);

  useEffect(() => {
    setTimeout(() => {
      if (refCurrent && scrollTop) {
        refCurrent.scrollTo({
          top: Number(scrollTop),
          behavior: "smooth",
        });
      }
      // setTimeout и timeoutDelay - это костыль, но не придумал, как сделать по-другому
    }, timeoutDelay);
  }, [refCurrent]);

  return { ref };
};

export default useScrollMemory;
